"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Currency = /** @class */ (function () {
    function Currency(defaultMoneyFormat) {
        this.defaultMoneyFormat = defaultMoneyFormat;
        this.placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        this.formatOptions = this.getFormatOptions(defaultMoneyFormat);
        this.moneyFormat = this.defaultMoneyFormat;
    }
    Currency.prototype.format = function (cents, moneyFormat) {
        this.moneyFormat = moneyFormat ? moneyFormat : this.defaultMoneyFormat;
        this.formatOptions = this.getFormatOptions(this.moneyFormat);
        return this.moneyFormat.replace(this.placeholderRegex, this.formatWithDelimiters(cents));
    };
    Currency.prototype.getFormatOptions = function (moneyFormat) {
        var precision = 2, thousands = ',', decimal = '.';
        switch (moneyFormat.match(this.placeholderRegex)[1]) {
            case 'amount':
                precision = 2;
                break;
            case 'amount_no_decimals':
                precision = 0;
                break;
            case 'amount_with_comma_separator':
                precision = 2, thousands = '.', decimal = ',';
                break;
            case 'amount_no_decimals_with_comma_separator':
                precision = 0, thousands = '.', decimal = ',';
                break;
        }
        return {
            precision: precision,
            thousands: thousands,
            decimal: decimal
        };
    };
    Currency.prototype.parseFromStringToPrice = function (price) {
        var unit = this.moneyFormat.substring(0, 1);
        return parseFloat(price.replace(unit, '').replace(/,/g, '')) * 100;
    };
    Currency.prototype.formatWithDelimiters = function (cents) {
        if (typeof cents === 'string')
            cents = parseInt(cents);
        if (isNaN(cents) || cents == null)
            return '0';
        var moneyString = (cents / 100.0).toFixed(this.formatOptions.precision);
        var parts = moneyString.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(this.formatOptions.thousands));
        cents = parts[1] ? this.formatOptions.decimal + parts[1] : '';
        return dollars + cents;
    };
    return Currency;
}());
exports.default = new Currency(window.theme.shop.moneyFormat);
